var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 8.78418 8.78418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 8.78418,
    opacity: 0,
    width: 8.78418,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.834961 8.7793L7.38281 8.7793C7.90527 8.7793 8.21777 8.53516 8.21777 8.12988C8.21777 6.87012 6.64062 5.13184 4.10645 5.13184C1.57715 5.13184 0 6.87012 0 8.12988C0 8.53516 0.3125 8.7793 0.834961 8.7793ZM4.11133 4.25781C5.15625 4.25781 6.06445 3.32031 6.06445 2.09961C6.06445 0.893555 5.15625 0 4.11133 0C3.06641 0 2.1582 0.913086 2.1582 2.10938C2.1582 3.32031 3.06152 4.25781 4.11133 4.25781Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cac6b5328fa8228915963baeb9686f2a.svg";
export { ForwardRef as ReactComponent };